import { Layout } from "components/styleguide";
import { EventLayoutContext } from "layouts/EventLayout/types";
import React, { FC } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

const CompanyLayout: FC = () => {
  const { id, forum } = useOutletContext<EventLayoutContext>();

  return (
    <div>
      <Layout.Content>
        <Outlet context={{ id, forum }} />
      </Layout.Content>
    </div>
  );
};

export default CompanyLayout;
